import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        const hash = location.hash.substring(1);
        const params = new URLSearchParams(hash);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/');
          return;
        }

        const response = await fetch(`${BACKEND_URL}/api/auth/session`, {
          method: 'POST',
          headers: {
            'X-Session-ID': sessionId
          },
          credentials: 'include'
        });

        if (!response.ok) {
          const error = await response.json();
          alert(error.detail || 'Authentication failed');
          navigate('/');
          return;
        }

        const data = await response.json();
        
        navigate('/dashboard', { state: { user: data.user }, replace: true });
      } catch (error) {
        console.error('Auth error:', error);
        alert('Authentication failed. Please try again.');
        navigate('/');
      }
    };

    processSession();
  }, [navigate, location]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-[#A2FF00] text-xl">Authenticating...</div>
    </div>
  );
};

export default AuthCallback;
